import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'pw-button',
  templateUrl: './pw-button.component.html',
  styleUrls: ['./pw-button.component.scss']
})
export class PwButtonComponent implements OnInit {
  
  @Input() data: any;
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  click(event) {
    this.onClick.emit(event);
  }

}
